import React from "react";

const STATUS = {
  DRAFT: ["Draft", "bg-slate-50 text-slate-600 border-slate-200"],
  IN_REVIEW: ["In Review", "bg-blue-50 text-blue-700 border-blue-200"],
  CHANGES_REQUESTED: ["Changes Requested", "bg-orange-50 text-orange-700 border-orange-200"],
  APPROVED: ["Approved", "bg-indigo-50 text-indigo-700 border-indigo-200"],
  READY_TO_SEND: ["Ready to Send", "bg-teal-50 text-teal-700 border-teal-200"],
  READY_FOR_SIGNATURE: ["Ready for Signature", "bg-violet-50 text-violet-700 border-violet-200"],
  SENT_TO_PARTNER: ["Sent to Partner", "bg-cyan-50 text-cyan-700 border-cyan-200"],
  VIEWED: ["Viewed by Partner", "bg-sky-50 text-sky-700 border-sky-200"],
  REVISION_IN_PROGRESS: ["Revision in Progress", "bg-orange-50 text-orange-700 border-orange-200"],
  SENT_FOR_SIGNATURE: ["Sent for Signature", "bg-cyan-50 text-cyan-700 border-cyan-200"],
  PARTIALLY_SIGNED: ["Partially Signed", "bg-amber-50 text-amber-700 border-amber-200"],
  FULLY_EXECUTED: ["Fully Executed", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  ACTIVE: ["Active", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  EXPIRED: ["Expired", "bg-orange-50 text-orange-700 border-orange-200"],
  RENEWED: ["Renewed", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  AMENDED: ["Amended", "bg-indigo-50 text-indigo-700 border-indigo-200"],
  CANCELLED: ["Cancelled", "bg-rose-50 text-rose-700 border-rose-200"],
  TERMINATED: ["Terminated", "bg-rose-50 text-rose-700 border-rose-200"],
};

const TYPE = {
  nda: ["NDA", "bg-blue-50 text-blue-700 border-blue-200"],
  sla: ["SLA", "bg-violet-50 text-violet-700 border-violet-200"],
  nda_sla: ["NDA+SLA", "bg-cyan-50 text-cyan-700 border-cyan-200"],
  client_agreement: ["CLIENT", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  vendor_agreement: ["VENDOR", "bg-amber-50 text-amber-700 border-amber-200"],
  staffing_agreement: ["STAFFING", "bg-teal-50 text-teal-700 border-teal-200"],
  msa: ["MSA", "bg-indigo-50 text-indigo-700 border-indigo-200"],
  amendment: ["AMENDMENT", "bg-orange-50 text-orange-700 border-orange-200"],
  custom: ["CUSTOM", "bg-slate-100 text-slate-600 border-slate-200"],
};

export function AgreementStatusBadge({ status }) {
  const [label, cls] = STATUS[status] || [String(status || "—").replace(/_/g, " "), "bg-slate-50 text-slate-600 border-slate-200"];
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`} data-testid={`agreement-status-${status}`}>{label}</span>;
}

export function AgreementTypeBadge({ type }) {
  const [label, cls] = TYPE[type] || [String(type || "—").toUpperCase(), "bg-slate-50 text-slate-600 border-slate-200"];
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-bold tracking-wide ${cls}`}>{label}</span>;
}
